<template>
  <div class="rows-container">
    <div class="row">
      <div class="title">
        <p>{{ $t("requestsPage.pending") }} </p>
          
      </div>
      <InfinityScroll status="PENDING" time="INSTANT" ref="PENDING" :besoin="this.besoin" @loaded="pushID($event);" @reconciled="reconcileIDs($event)"
        @updateTotal="totalPendingOrders = $event" @decreaseCount="totalPendingOrders--" />
    </div>
    <div class="row">
      <div class="title">
        <p>{{ $t("requestsPage.dispatched") }}</p>
      </div>
      <InfinityScroll status="ACCEPTED" time="INSTANT" ref="ACCEPTED" :besoin="this.besoin"
        @loaded="pushID($event)" @reconciled="reconcileIDs($event)" />
    </div>
    <div class="row">
      <div class="title">
        <p>{{ $t("requestsPage.driverOnTheWay") }}</p>
      </div>
      <InfinityScroll multiStatus="ARRIVED|STARTED" time="INSTANT" ref="ARRIVED" :besoin="this.besoin"
        @loaded="pushID($event)" @reconciled="reconcileIDs($event)" />
    </div>
    <div class="row">
      <div class="title">
        <p>{{ $t("requestsPage.tripStarted") }}</p>
      </div>
      <InfinityScroll status="PICKED_UP" time="INSTANT" ref="PICKED_UP" :besoin="this.besoin"
        @loaded="pushID($event)" @reconciled="reconcileIDs($event)" />
    </div>
    <div class="row">
      <div class="title">
        <p>{{ $t("requestsPage.completed") }}</p>
      </div>
      <InfinityScroll multiStatus="DONE|PAID|SYSTEM_CANCELLED|PASSENGER_CANCELLED|CAPTAIN_CANCELLED|CC_CANCELLED" time="INSTANT" ref="DONE" :besoin="this.besoin"
        @loaded="pushID($event)" @reconciled="reconcileIDs($event)" />
    </div>
  </div>
</template>

<script>
import InfinityScroll from "@/components/dispatching/InfinityScroll.vue";
import socketEventsMixin from "@/mixins/socketEventsMixin.js";
import api from "@/constants/api.js";
import axios from "axios";

export default {
  name: "instant-orders",
  mixins: [socketEventsMixin],
  data() {
    return {
      ordersIDs: {
        CANCELLED: [],
      },
      pendingOrdersCount: [],
      totalPendingOrders: 0,
      besoin: 0,
      lastUpdate: '',
      refreshTimer: null
    };
  },
  events() {
    return {
      // A dropped-and-recovered socket silently loses every frame it missed,
      // so resync the whole board the moment it reconnects. The mixin binds
      // and unbinds everything in this map, including a rebind when the store
      // replaces the socket instance.
      connect: this.refreshAll,
      [this.api.SOCKET.EVENTS.NEW_NOW_BOOKING]: this.newNowBooking,
      [this.api.SOCKET.EVENTS.UPDATE_BOOKING_STATUS]: this.updateStatus,
      [this.api.SOCKET.EVENTS.RENEW_BESOIN]: this.renewBesoin,
      [this.api.SOCKET.EVENTS.EXPIRED_BESOIN]: this.expiredBesoin,
      [this.api.SOCKET.EVENTS.NEW_PENDING_BOOKING]: this.increasePendingBookingsCount,
      [this.api.SOCKET.EVENTS.UPDATE_BOOKING]: this.decreasePendingBookingsCount
    };
  },
  components: {
    InfinityScroll,
  },
  methods: {
    getPendingOrdersCount() {
      // axios.get('pending_bookings_count/INSTANT',)
      //   .then((res) => {
      //     this.pendingOrdersCount = res.data.data;

      //   })
      //   .catch((err) => {
      //     this.errorMessage = err.response.data.message;
      //     console.log("err");
      //     console.log(this.errorMessage);
      //   })
    },
    pushID(evt) {
      let status = "";
      if (evt.status === "ACCEPTED" )
        status = "ACCEPTED";
      else if (evt.status === "ARRIVED" || evt.status === "STARTED")
        status = "ARRIVED";
      else status = evt.status;

      let id = evt.id;
      if (this.ordersIDs[status]) {
        // Idempotent: a reconcile reports ids the bucket may already hold, and
        // a duplicate entry makes updateStatus walk the same order twice.
        if (this.ordersIDs[status].indexOf(id) === -1) this.ordersIDs[status].push(id);
      } else {
        this.ordersIDs[status] = [];
        this.ordersIDs[status].push(id);
      }
    },
    expiredBesoin(besoin) {
      // this.$store.commit("DELETE_BESOIN", besoin.booking_id);
      // console.log(this.$store.state.besoins);
    },
    renewBesoin(besoin) {
      this.besoin = besoin.booking_id;
      // this.$store.commit("SET_BESOIN", this.besoin);
      // console.log(this.$store.state.besoins);
    },
    updateStatus(id, newStatus, oldStatus, driver, ride_id, cancellationReason = null) {
      console.log(driver)
      //console.log(id, newStatus, oldStatus)
      let cancelled = ['CC_CANCELLED', 'CAPTAIN_CANCELLED', 'PASSENGER_CANCELLED', 'SYSTEM_CANCELLED'].includes(newStatus);

      let refName = "";
      if (newStatus === "ACCEPTED")
        refName = "ACCEPTED";
      else if (newStatus === "ARRIVED" || newStatus === "STARTED")
        refName = "ARRIVED";
      else if (cancelled || newStatus == 'PAID')
        refName = 'DONE';
      else refName = newStatus;
      if (this.lastUpdate != `${id}:${newStatus}:${oldStatus}` && (newStatus === "ACCEPTED"  || (cancelled && oldStatus === "PENDING")))
        this.totalPendingOrders--;
      this.lastUpdate = `${id}:${newStatus}:${oldStatus}`;

      if (newStatus !== "PENDING") {
        this.$store.dispatch('updateBookingData', {
          id, newStatus, oldStatus, driver
        });
      }

      Object.entries(this.ordersIDs).forEach(([key, value]) => {
        for (let i = 0; i < value.length; i++) {
          if (value[i] === id && oldStatus !== "DONE") {

            let refKey = "";
            if (key === "ACCEPTED" ) refKey = "ACCEPTED";
            else if (key === "ARRIVED" || key === "STARTED") refKey = "ARRIVED";
            else refKey = key;

            // removeOrder returns undefined when the id is not in that column,
            // and pushID can create raw-status keys (e.g. CAPTAIN_CANCELLED)
            // for which no column ref exists. Either case threw a TypeError
            // inside this forEach, which aborted the whole socket handler and
            // froze every card that should have been updated after it.
            let sourceColumn = this.$refs[refKey];
            let order = sourceColumn ? sourceColumn.removeOrder(id) : null;
            if (!order) return;

            order.status = refName == 'DONE' && !cancelled ? 'PAID' : newStatus;
            if (driver) {
              order['captain_first_name'] = driver.first_name;
              order['captain_last_name'] = driver.last_name;
              order['taxi_number'] = driver.username;
              order['car_brand_model'] = driver.car_brand_model;
              order['car_brand_name'] = driver.car_brand_name;
              order['car_color'] = driver.car_color;
              order['car_plate_number'] = driver.car_plate_number;
            }
            if (cancellationReason) {
              if (newStatus == "CAPTAIN_CANCELLED")
                order['captain_cancellation_reason'] = cancellationReason;
              else if (newStatus == 'SYSTEM_CANCELLED' || newStatus == 'REJECTED')
                order['user_cancellation_reason'] = cancellationReason;

            }

            let targetColumn = this.$refs[refName];
            if (targetColumn) targetColumn.addOrder(order);

            if (this.ordersIDs[refKey])
              this.ordersIDs[refKey].splice(
                this.ordersIDs[refKey].indexOf(id),
                1
              );

            this.pushID({ status: refName, id: id });

            break;
          }
        }
      });
      this.getPendingOrdersCount();
    },
    newNowBooking(bookingData) {
      console.log("bookingData",bookingData)
      this.$refs["PENDING"].addOrder(bookingData);
      this.totalPendingOrders++;
      this.pushID({ status: "PENDING", id: bookingData.id });
      this.getPendingOrdersCount();
    },
    increasePendingBookingsCount(data) {
      // this.totalPendingOrders++;
      console.log(data);
    },
    // Ask every column to reconcile itself against the server, so a frame the
    // socket never delivered cannot leave a card stuck in the wrong column
    // until the operator presses F5. Nothing is torn down here: each column
    // merges its own answer into the cards it is already showing
    // (refreshInPlace) and rebuilds its own id buckets through @reconciled.
    // Wiping ordersIDs up front meant a socket frame arriving while the five
    // requests were in flight found no bucket at all and froze its card.
    refreshAll() {
      ["PENDING", "ACCEPTED", "ARRIVED", "PICKED_UP", "DONE"].forEach((refName) => {
        let column = this.$refs[refName];
        if (column && typeof column.refreshInPlace === "function")
          column.refreshInPlace();
      });
    },
    // Rebuild the id bookkeeping of ONE column, from the rows that column just
    // reconciled. Buckets are owned per column (PENDING, ACCEPTED, ARRIVED +
    // STARTED, PICKED_UP, and the six terminal statuses of the DONE column), so
    // this can never drop an id another column has just claimed.
    reconcileIDs(payload) {
      if (!payload || !Array.isArray(payload.rows)) return;
      let keys = Array.isArray(payload.keys) ? payload.keys : [];
      keys.forEach((key) => {
        if (!key) return;
        // pushID files ARRIVED and STARTED in the same bucket.
        let bucket = key === "STARTED" ? "ARRIVED" : key;
        if (this.ordersIDs[bucket]) this.ordersIDs[bucket] = [];
      });
      payload.rows.forEach((row) => this.pushID(row));
    },
  },
  created() {
    this.getPendingOrdersCount();
    this.refreshTimer = setInterval(this.refreshAll, 30000);
  },
  beforeDestroy() {
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer);
      this.refreshTimer = null;
    }
    // socketEventsMixin already unbinds everything in events(); this is the
    // explicit belt-and-braces removal of the resync listener.
    if (this.socket) this.socket.removeListener("connect", this.refreshAll);
  }
};
</script>

<style lang="scss" scoped>
.rows-container {
  width: 100%;
  height: 100%;
  float: inline-start;
  display: flex;
  flex-direction: row;
  background-color: white;
  box-shadow: 0px 2px 6px rgba(0, 11, 138, 0.08);
  border-radius: 10px;
  margin-top: 20px;

  .row {
    flex-shrink: 0;
    flex: 1;
    min-width: 200px;
    min-height: 600px;
    max-height: 600px;
    float: inline-start;
    padding-top: 16px;
    height: 100%;
    opacity: 0.9;

    .title {
      height: 50px;
      width: 100%;
      padding-bottom: 16px;
      float: inline-start;
      border-bottom: 1px solid #c1c5d8;

      p {
        width: 100%;
        font-size: 14px !important;
        text-align: center;
        font-weight: 500;
        color: #4d4f5c;
        font-family: Poppins !important;
        padding: 0px;
        margin: 1%;
      }
    }

    &:not(:last-child) {
      border-inline-end: 1px solid #c1c5d8;
    }

    &:hover {
      opacity: 1;
    }
  }
}
</style>
